import LogBuffer, { LogType } from '../logbuffer';
import LogReporter from '../logreporter';
const LogLevel = {
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error'
};
const LogLevelOrder = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3
};
const loggerConfig = {
    level: LogLevel.INFO,
    name: undefined,
    consoleApi: console
};
const getOrder = (level)=>LogLevelOrder[level];
const Logger = {
    configure (options = {}) {
        if (options.level) {
            loggerConfig.level = options.level;
        }
        if (options.name) {
            loggerConfig.name = options.name;
        }
        if (options.logger) {
            loggerConfig.consoleApi = options.logger;
        }
    },
    setLogLevel (level) {
        loggerConfig.level = level;
        console.log('Log level set to:', level);
    },
    getLogLevel () {
        return loggerConfig.level;
    },
    logAndSend (logObject, level, logType) {
        this.log(logObject, level, logType);
        LogReporter.report();
    },
    debug (logObject, logType) {
        this.log(logObject, LogLevel.DEBUG, logType ? logType : LogType.CUSTOM);
    },
    error (logObject, logType) {
        this.log(logObject, LogLevel.ERROR, logType ? logType : LogType.ERROR);
    },
    info (logObject, logType) {
        this.log(logObject, LogLevel.INFO, logType ? logType : LogType.CUSTOM);
    },
    warn (logObject, logType) {
        this.log(logObject, LogLevel.WARN, logType ? logType : LogType.CUSTOM);
    },
    log (logObject, level, logType) {
        const logMethod = level ? level : 'log';
        const order = level ? getOrder(level) : LogLevelOrder.debug;
        // TODO Add upper limit for buffer max capacity
        if (order >= getOrder(loggerConfig.level)) {
            const dt = new Date();
            LogBuffer.add(loggerConfig.name, dt, logType, logObject);
            const dtString = `${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()} ${dt.getMilliseconds()}`;
            const logHeader = `[${loggerConfig.name}][${dtString}]`;
            loggerConfig.consoleApi[logMethod](logHeader, logObject);
        }
    }
};
export { LogLevel };
export default Logger;
